import React, { Component } from "react";
import PropTypes from "prop-types";
import { Tooltip, Polyline } from "react-leaflet";
import "leaflet-polylineoffset";
import { withNamespaces } from "react-i18next";
import PolylineHelper from "../../utils/polylineHelper";

class MapRoute extends Component {
  static propTypes = {
    visualRoute: PropTypes.any,
    t: PropTypes.func.isRequired,
    platonRate: PropTypes.number
  };

  static defaultProps = {
    visualRoute: {}
  };

  render() {
    const { visualRoute, t, platonRate, map } = this.props;
    const polylineHelper = new PolylineHelper({ t });
    const polylines = polylineHelper.mapPointsToPolylines(visualRoute, platonRate, map);
    
    return polylines.map(polyline => (
      <Polyline
          key={polyline.key}
          positions={polyline.positions}
          color={polyline.color}
          opacity={0.85}
          lineJoin="round"
          lineCap="round"
          stroke
          dashArray={polyline.isDashed ? "3 10" : null}
          weight={5}
      >
        <Tooltip sticky opacity={1.0}>
          <span>{polyline.tooltip}</span>
        </Tooltip>
      </Polyline>
    ));
  }
}

export default withNamespaces()(MapRoute);
